export default class SourceScraper
{

  constructor(scraper = {}) 
  {
    this.type = scraper.type || ''
    this.handler = 'Snitches\\Scrapers\\SourceCodeLookup'
    this.identifier = scraper.identifier || {
      name: ''
    }
    this.extracts = scraper.extracts || {
      class: ''
    }
    this.search_path = scraper.search_path || ''
  }

  static mutations() {
    return {
      updateScraperType: (state, payload) => state.scraper.type = payload,
      updateIdentifier: (state, payload) => state.scraper.identifier.name = payload,
      updateExtraction: (state, payload) => state.scraper.extracts.class = payload,
      updateSearchPath: (state, payload) => state.scraper.search_path = payload,
    }
  }

}